import { useState } from "react";
import { MessageCircle, X, Car, MapPinned, Wrench, Phone } from "lucide-react";
import { PHONES, buildWhatsAppLink } from "@/lib/constants";

const items = [
    {
        key: "aluguel",
        label: "Aluguel de Carros",
        phone: PHONES.aluguel,
        Icon: Car,
        message: "Olá! Tenho interesse no aluguel de veículos da PEG. Pode me ajudar?",
    },
    {
        key: "rastreamento",
        label: "Rastreamento Veicular",
        phone: PHONES.rastreamento,
        Icon: MapPinned,
        message: "Olá! Quero saber mais sobre o rastreamento veicular da PEG.",
    },
    {
        key: "guincho",
        label: "Guincho 24h",
        phone: PHONES.guincho,
        Icon: Wrench,
        message: "Olá! Preciso de um guincho. Pode me atender?",
    },
];

export default function WhatsAppFloat() {
    const [open, setOpen] = useState(false);

    return (
        <>
            {open && (
                <div
                    data-testid="whatsapp-panel"
                    className="fixed bottom-24 right-6 z-50 w-[320px] max-w-[calc(100vw-3rem)] bg-white shadow-2xl border-2 border-[#1a1a1a]"
                >
                    <div className="bg-[#1a1a1a] text-white px-5 py-4 flex items-center justify-between">
                        <div>
                            <p className="font-display font-bold text-lg leading-none">
                                Fale com a PEG
                            </p>
                            <p className="text-xs text-white/60 mt-1">
                                Escolha o serviço que você precisa
                            </p>
                        </div>
                        <button
                            onClick={() => setOpen(false)}
                            data-testid="whatsapp-panel-close"
                            className="text-white/70 hover:text-[#fec200]"
                        >
                            <X className="w-5 h-5" />
                        </button>
                    </div>
                    <div className="p-3 space-y-2">
                        {items.map(({ key, label, phone, Icon, message }) => (
                            <a
                                key={key}
                                href={buildWhatsAppLink(phone.raw, message)}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid={`whatsapp-quick-${key}`}
                                className="group flex items-center gap-3 p-3 hover:bg-[#fec200] hover:text-[#1a1a1a] transition-colors border border-transparent hover:border-[#1a1a1a]"
                            >
                                <div className="w-10 h-10 bg-[#fec200] group-hover:bg-[#1a1a1a] group-hover:text-[#fec200] flex items-center justify-center text-[#1a1a1a] transition-colors">
                                    <Icon className="w-5 h-5" />
                                </div>
                                <div className="flex-1">
                                    <div className="font-bold text-sm">{label}</div>
                                    <div className="text-xs text-[#4a4a4a] group-hover:text-[#1a1a1a] inline-flex items-center gap-1">
                                        <Phone className="w-3 h-3" />
                                        {phone.display}
                                    </div>
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
            )}

            <button
                onClick={() => setOpen((o) => !o)}
                data-testid="whatsapp-float-button"
                aria-label="Abrir contato WhatsApp"
                className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#1ebe5c] text-white p-4 rounded-full shadow-2xl transition-transform hover:scale-110"
            >
                <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" />
                <MessageCircle className="w-6 h-6 relative" />
            </button>
        </>
    );
}
